import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from 'components/pure/utils/Dialog';
import TextAreaField from 'components/pure/utils/form/TextAreaField';
import {ClipboardIcon} from '@components/icon/ClipboardIcon';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';

export default class CoachNotesEdit extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showNotesModal: false,
      showNotesPopover: false,
      notes: props.coachNotes,
    };

    this.toggleNotesModal = this.toggleNotesModal.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.coachNotes !== nextProps.coachNotes) {
      this.setState({notes: nextProps.coachNotes});
    }
  }

  toggleNotesModal() {
    this.setState({showNotesModal: !this.state.showNotesModal});
  }

  onCancel() {
    this.setState({
      notes: this.props.coachNotes,
      showNotesModal: false,
    });
  }

  onSubmit() {
    this.props.onChange(this.state.notes);
    this.setState({
      showNotesModal: false,
    });
  }

  renderCell() {
    const {coachNotes} = this.props;
    if (coachNotes) {
      return (
        <div className="coach-notes-edit">
          <GenericTooltip positionTop className="clipboard-wrapper" tooltip={coachNotes}>
            <ClipboardIcon
              onMouseEnter={() => this.setState({showNotesPopover: true})}
              onMouseLeave={() => this.setState({showNotesPopover: false})}
            />
          </GenericTooltip>
          <Button variant="outlined" className="ev-button" onClick={this.toggleNotesModal}>
            Edit
          </Button>
        </div>
      );
    }

    return (
      <div className="coach-notes-edit">
        <span className="icon-placeholder"></span>
        <Button variant="outlined" className="ev-button" onClick={this.toggleNotesModal}>
          Add
        </Button>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderCell()}
        <Dialog
          className="coach-notes-dialog"
          modal={true}
          open={this.state.showNotesModal}
          title="Coach Notes"
          onRequestClose={this.onCancel}
          actions={
            <div className="coach-notes-actions">
              <Button variant="outlined" className="ev-button" onClick={this.onCancel}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                className="ev-button"
                onClick={this.onSubmit}>
                Submit
              </Button>
            </div>
          }>
          <TextAreaField
            autoFocus
            className="coach-notes-text-area"
            value={this.state.notes}
            onChange={val => this.setState({notes: val})}
          />
        </Dialog>
      </div>
    );
  }
}
